import React, { useState, useContext, useEffect } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { ItemContext } from "../../context/ItemContext";
import { FormHelperText } from "@mui/material";

const CheckboxGroupComponent = ({
  options,
  priceOfItem,
  onTotalOptionChange,
  handleOptionChange,
  isEditMode,
  editOptions,
}) => {
  const { totalOption, setTotalOption } = useContext(ItemContext);
  const [selectedValues, setSelectedValues] = useState([]);
  const [error, setError] = useState(false);

  // Initialize selected values from editOptions when in edit mode
  useEffect(() => {
    if (isEditMode && editOptions) {
      // Extract option names from editOptions and set them as selected values
      const editOptionNames = editOptions
        .filter(opt => options.some(option => option.name === opt.name))
        .map(opt => opt.name);

      setSelectedValues(editOptionNames);

      // Notify parent that options are already selected (if any)
      if (editOptionNames.length > 0) {
        handleOptionChange(true);
      }
    }
  }, [isEditMode, editOptions, options, handleOptionChange]);

  const handleCheckboxChange = (value, optionObj) => {
    setError(false);
    const isChecked = selectedValues.includes(value);
    const selectedOption = options.find((option) => option.name === value);

    if (!selectedOption) return;

    let newSelectedValues;
    if (isChecked) {
      // Deselecting an option
      newSelectedValues = selectedValues.filter((val) => val !== value);

      setTotalOption(totalOption - Number(selectedOption.price));
      // Call the onTotalOptionChange function to update options in parent component
      onTotalOptionChange(optionObj, false);

      handleOptionChange(newSelectedValues.length > 0);
    } else {
      // This group only allows one selection at a time
      newSelectedValues = [value];

      // Remove price of any previously selected option
      const previousSelection = selectedValues.length > 0
        ? options.find(opt => opt.name === selectedValues[0])
        : null;

      if (previousSelection) {
        setTotalOption(totalOption - Number(previousSelection.price) + Number(selectedOption.price));
      } else {
        setTotalOption(totalOption + Number(selectedOption.price));
      }

      // Call the onTotalOptionChange function to update options in parent component
      onTotalOptionChange(optionObj, true);
      handleOptionChange(true);
    }

    // Update the local state
    setSelectedValues(newSelectedValues);
  };

  return (
    <>
      <FormGroup style={{ flexDirection: "row" }}>
        {options.map((option) => (
          <FormControlLabel
            style={{ color: "black" }}
            key={option.id || option.name}
            control={
              <Checkbox
                checked={selectedValues.includes(option.name)}
                onChange={() => handleCheckboxChange(option.name, option)}
                disabled={
                  selectedValues.length > 0 &&
                  !selectedValues.includes(option.name)
                }
              />
            }
            label={`${option.name} - $${option.price / 100}`}
          />
        ))}
        {error && <FormHelperText style={{ color: "red" }}>Please select one</FormHelperText>}
      </FormGroup>
    </>
  );
};

export default CheckboxGroupComponent;